
const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 1; i < 191; i++){
            listImg.push(`http://localhost:8081/media/${lang}/ccSynchro/synchronisation_cc_${i.toString().padStart(3, '0')}.jpg`)
        }
    } else {
        for(let i = 1; i < 191; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/ccSynchro/synchronisation_cc_${i.toString().padStart(3, '0')}.jpg`)
        }
    }
    return listImg;
}
export default images;
